module.exports = __webpack_public_path__ + "img/instagram.cf5618ee.svg";